import React, { useState } from "react";
import { getCollegesForProgram, seatCategories, getCutoffForCollegeProgram } from "./data/colleges";
import { getCollegeImagePath, getCollegeGradient } from "./data/universityImages";

const CollegeModal = ({ program, onClose }) => {
    const [activeTab, setActiveTab] = useState("seats");
    const colleges = getCollegesForProgram(program.name);

    // Use first college for hero image
    const heroCollege = colleges[0];
    const heroImage = heroCollege ? getCollegeImagePath(heroCollege.name) : null;
    const heroGradient = heroCollege ? getCollegeGradient(heroCollege.name) : ['#1e3a5f', '#2563eb'];

    // Display categories for the table — maps display label to data key
    const displayCategories = [
        { label: "UR", seatKey: "UR", cutoffKey: "UR" },
        { label: "OBC-NCL", seatKey: "OBC_NCL", cutoffKey: "OBC" },
        { label: "SC", seatKey: "SC", cutoffKey: "SC" },
        { label: "ST", seatKey: "ST", cutoffKey: "ST" },
        { label: "EWS", seatKey: "EWS", cutoffKey: "EWS" },
    ];

    const getTotalSeats = (college) => {
        return seatCategories.reduce((sum, cat) => {
            return sum + (typeof college.seats[cat] === 'number' ? college.seats[cat] : 0);
        }, 0);
    };

    const formatCutoff = (val) => {
        if (val === null || val === undefined) return "—";
        return typeof val === 'number' ? val.toFixed(1) : val;
    };

    return (
        <div className="elig-modal-overlay" onClick={onClose}>
            <div className="elig-modal" onClick={(e) => e.stopPropagation()}>
                {/* Hero Banner */}
                <div
                    className="elig-modal__hero"
                    style={{
                        background: heroImage
                            ? `linear-gradient(to bottom, ${heroGradient[0]}cc, ${heroGradient[1]}ee), url(${heroImage}) center/cover`
                            : `linear-gradient(135deg, ${heroGradient[0]}, ${heroGradient[1]})`,
                    }}
                >
                    <button className="elig-modal__close" onClick={onClose}>✕</button>
                    <div className="elig-modal__hero-content">
                        <h2 className="elig-modal__title">{program.name}</h2>
                        <p className="elig-modal__hero-sub">
                            {colleges.length} {colleges.length === 1 ? 'College' : 'Colleges'} offering this program
                        </p>
                    </div>
                </div>

                {/* Tabs */}
                <div className="elig-modal__tabs-bar">
                    <button
                        className={`elig-modal-tab ${activeTab === "seats" ? "elig-modal-tab--active" : ""}`}
                        onClick={() => setActiveTab("seats")}
                    >
                        📊 Seat Matrix
                    </button>
                    <button
                        className={`elig-modal-tab ${activeTab === "cutoffs" ? "elig-modal-tab--active" : ""}`}
                        onClick={() => setActiveTab("cutoffs")}
                    >
                        📈 Previous Year Cutoffs
                    </button>
                </div>

                {/* Body */}
                <div className="elig-modal__body">
                    <div className="elig-modal__section-header">
                        <h3>
                            {activeTab === "seats" ? "Seat Distribution 2024-25" : "Cutoff Scores 2023-24"}
                        </h3>
                        <p>
                            {activeTab === "seats"
                                ? "Allocation based on CUET scores and category reservations."
                                : "Previous year CUET cutoff scores by category."}
                        </p>
                    </div>

                    <div className="elig-data-table-wrapper">
                        <table className="elig-data-table">
                            <thead>
                                <tr>
                                    <th>COLLEGE NAME</th>
                                    {displayCategories.map((cat) => (
                                        <th key={cat.label}>{cat.label}</th>
                                    ))}
                                    {activeTab === "seats" && <th>TOTAL</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {colleges.map((college, idx) => {
                                    const cutoffs = activeTab === "cutoffs"
                                        ? getCutoffForCollegeProgram(college.name, program.name)
                                        : null;
                                    return (
                                        <tr key={idx}>
                                            <td>{college.name}</td>
                                            {displayCategories.map((cat) => (
                                                <td key={cat.label}>
                                                    {activeTab === "seats"
                                                        ? (college.seats[cat.seatKey] || 0)
                                                        : formatCutoff(cutoffs ? cutoffs[cat.cutoffKey] : null)}
                                                </td>
                                            ))}
                                            {activeTab === "seats" && (
                                                <td className="elig-data-table__total">
                                                    {getTotalSeats(college)}
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* Info Cards */}
                    <div className="elig-modal__info-cards">
                        <div className="elig-info-card">
                            <div className="elig-info-card__icon">📅</div>
                            <div className="elig-info-card__label">Program Category</div>
                            <div className="elig-info-card__value">{program.category}</div>
                        </div>
                        <div className="elig-info-card">
                            <div className="elig-info-card__icon">🏛️</div>
                            <div className="elig-info-card__label">Total Colleges</div>
                            <div className="elig-info-card__value">{colleges.length}</div>
                        </div>
                        <div className="elig-info-card">
                            <div className="elig-info-card__icon">⭐</div>
                            <div className="elig-info-card__label">Eligibility Paths</div>
                            <div className="elig-info-card__value">
                                {program.combinations ? program.combinations.length : 1}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollegeModal;
